'use strict';

import React, { PropTypes } from 'react';
import ContextMenu from '../molecules/ContextMenu';
import ColorPicker from '../organisms/ColorPicker';
import ZineActionCreators from '../actions/ZineActionCreators';
import PureRenderMixin from '../mixins/PureRenderMixin';

const ZineColorPickerContextMenu = React.createClass({
  mixins: [PureRenderMixin],

  propTypes: {
    anchorRect: PropTypes.object.isRequired,
    previousColor: PropTypes.string
  },

  getInitialState() {
    return {
      didSelect: false
    };
  },

  render() {
    return (
      <ContextMenu anchorRect={this.props.anchorRect}>
        <ColorPicker onSelect={this.handleSelect}
                     onChange={this.handleChange}
                     context='ContextMenu'/>
      </ContextMenu>
    );
  },

  handleSelect(color) {
    ZineActionCreators.updateZineDraft('backColor', color);

    this.setState({
      didSelect: true
    });
  },

  handleChange(color) {
    // Avoid accidental changes while context menu is fading away
    if (this.state.didSelect) {
      return;
    }

    color = color || this.props.previousColor;
    ZineActionCreators.updateZineDraft('backColor', color);
  }
});

export default ZineColorPickerContextMenu;


/** WEBPACK FOOTER **
 ** ./contextMenus/ZineColorPickerContextMenu.jsx
 **/